export const formatAmount = (amount: number | string) => {
  const numericAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
  return numericAmount > 0 && numericAmount < 1 ? numericAmount : numericAmount.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ");
};
